import { useContext } from 'react';

import { BasketContext } from './context';

export const useBasketProvider = () => {
  return useContext(BasketContext);
};
